export const FeatureKeys = {
  MONEY_SNAPSHOT: 'money.snapshot',
  MONEY_RATIO: 'money.ratio',
  MONEY_TRANSACTIONS: 'money.transactions',
  MONEY_COACH: 'money.coach',
  MONEY_FORECAST: 'money.forecast',
  MONEY_CSV_IMPORT: 'money.csv_import',
  GOALS_CORE: 'goals.core',
  HOUSEHOLD_CORE: 'household.core',
  BUSINESS_CORE: 'business.core',
} as const;

export type FeatureKey = (typeof FeatureKeys)[keyof typeof FeatureKeys];

export function hasFeature(
  enabledFeatures: string[],
  key: FeatureKey,
): boolean {
  return enabledFeatures.includes(key);
}
